import { trans } from '@lingoda/i18n';
import { studentChallengePath } from '@lingoda/router';
import { Button, Paper, Stack, styled } from '@lingoda/ui';
import { getChallengeStatus, getChallengeStatusText, getChallengeTexts } from '../../utils';
import { ActiveChallengeWidgetHeader } from './ActiveChallengeWidgetHeader';

interface ActiveChallengeWidgetUnjoinedLayoutProps {
    challengeName: string;
    startDate: string;
    endDate: string;
    publicName: string;
    participants: number;
    challengeIconUrl: string | undefined;
    isJoining: boolean;
    onJoin: () => void;
}

export const ActiveChallengeWidgetUnjoinedLayout = (
    props: ActiveChallengeWidgetUnjoinedLayoutProps,
) => {
    const status = getChallengeStatus(props.startDate, props.endDate);
    const statusText = getChallengeStatusText(status, props.startDate, props.endDate);
    const { subtitle } = getChallengeTexts(props.challengeName, props.startDate);

    return (
        <CardPaper>
            <Stack spacing={2}>
                <ActiveChallengeWidgetHeader
                    subtitle={subtitle}
                    title={props.publicName}
                    iconUrl={props.challengeIconUrl}
                    statusText={statusText}
                    participants={props.participants}
                />
                <Stack direction="row" spacing={1}>
                    {status !== 'ended' && (
                        <Button
                            size="small"
                            variant="contained"
                            loading={props.isJoining}
                            onClick={props.onJoin}
                        >
                            {trans('btn-join-challenge', {}, 'student-challenges')}
                        </Button>
                    )}
                    <Button
                        size="small"
                        variant="outlined"
                        href={studentChallengePath({ challengeName: props.challengeName })}
                    >
                        {trans('btn-see-details', {}, 'student-challenges')}
                    </Button>
                </Stack>
            </Stack>
        </CardPaper>
    );
};

const CardPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3),
}));
